import { clsx } from 'clsx';

import { UniversalImage } from '../../image/UniversalImage';
import { Icons } from '../../icons/index';

import { getRadioChoiceId } from '../radioButton.utils';

import type { RadioButtonProps } from '../radioButton.types';

const classNameByValue = {
  'angry-red': 'hover:bg-red/20',
  'frowning-orange': 'hover:bg-orange/20',
  'neutral-blue': 'hover:bg-blue-500/20',
  'smiling-green': 'hover:bg-green/20',
  'winking-yellow': 'hover:bg-yellow/20',
};

export const RadioButtonSurvey = (props: RadioButtonProps) => {
  const { label, customId, isRequired, choices, adminLabel, classNames } =
    props;

  return (
    <fieldset
      id={customId}
      className={clsx(
        classNames?.container,
        'radio-button-survey flex flex-col divide-y divide-border'
      )}
    >
      <legend className='h3 pb-6'>{label}</legend>
      {Array.isArray(choices) &&
        choices.length > 0 &&
        choices.map((item) => {
          const { text, value } = item;

          const classes =
            classNameByValue[value as keyof typeof classNameByValue];

          const id = getRadioChoiceId(adminLabel, item);

          return (
            <label
              key={text}
              className={clsx(
                'flex relative items-center gap-3 pr-6 sm:px-6 pt-3 pb-6 duration-150 ease-out cursor-pointer',
                classes
              )}
            >
              <input
                type='radio'
                className='peer opacity-0 absolute bottom-0 w-0 h-0'
                id={id}
                name={adminLabel || customId}
                value={text}
                required={isRequired}
              />
              {classes ? (
                <UniversalImage
                  pattern='dimensions'
                  src={`/images/emoji/${value}.svg`}
                  alt={value as string}
                  width={48}
                  height={48}
                />
              ) : (
                <div className='w-10 h-10 flex items-center shrink-0 justify-center bg-white border border-border peer-checked:bg-blue-400 rounded-full duration-150 ease-out'>
                  <Icons
                    icon='checkmarkBold'
                    className='w-5 h-5 bg-white'
                    isInteractive
                  />
                </div>
              )}
              <span className='text-body-small md:text-body-xl'>{text}</span>
            </label>
          );
        })}
    </fieldset>
  );
};
